import { ScrollArea } from "@/components/flexkit/ScrollArea";
import { cn } from "@/components/podkit/lib/cn";
import { EnvironmentDetails } from "@/routes/environments/details/EnvironmentDetails";
import type { FC } from "react";

export type DetailsTabPanelProps = {
    environmentId: string;
    isHidden: boolean;
};

export const DetailsTabPanel: FC<DetailsTabPanelProps> = ({ environmentId, isHidden }) => {
    return (
        <div
            id="details-panel"
            role="tabpanel"
            aria-labelledby="details-tab"
            className={cn("flex min-h-0 flex-1 flex-col", isHidden && "hidden")}
        >
            <ScrollArea orientation="vertical" className="mx-0.5 my-0.5 h-full gap-6 p-4">
                <EnvironmentDetails environmentId={environmentId} showingAgentConversation={true} />
            </ScrollArea>
        </div>
    );
};
